import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Steps from './Steps';
import Button from '../../components/Button';
import { PhoneField } from '../../components/FieldKit';

import Api, { Utils } from '../../Api';

export default class CreateAccount extends React.Component {
  constructor(props) {
    super(props);

    Utils.bindThis(this, [ 'btnContinue', 'nextStep', 'onChange' ]);

    this.state = {
      validnames: true,
      validphone: true,
      validemail: true,
      accountExists: false,
      first_name: '',
      last_name: '',
      email_address: '',
      phone_number: '',
      error: null
    };
  }

  btnContinue() {
    let data = {
      first_name: (this.state.first_name || '').trim(),
      last_name: (this.state.last_name || '').trim(),
      email_address: (this.state.email_address || '').trim(),
      phone_number: this.state.phone_number
    };

    let stateChange = {
      validnames: true,
      validphone: true,
      validemail: true,
      accountExists: false
    };

    // Validate the data

    if (!data.first_name || data.first_name.trim().length === 0 || !data.last_name || data.last_name.trim().length === 0) {
      stateChange.validnames = false;
    }

    // E-Mail
    if (!data.email_address || data.email_address.length < 5) {
      stateChange.validemail = false;
    } else {
      let regex = /[A-Z0-9._%'=+][A-Z0-9._%'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}/iugy;
      if (!regex.exec(data.email_address)) stateChange.validemail = false;
    }

    // Phone Number
    if (!data.phone_number || data.phone_number.length < 9) {
      stateChange.validphone = false;
    } else {
      // Strip the following characters from the number: +, -, SPACE, DOT, ( and ).
      let actualPhoneNumber = data.phone_number.replace(/[ \-\(\)\.+]*/g, '');
      if (actualPhoneNumber.match(/[^0-9]/)) {
        // We can only have numbers left
        stateChange.validphone = false;
      } else if (actualPhoneNumber.length < 9 || actualPhoneNumber.length > 10) {
        // Length should be between 9 and 10.
        stateChange.validphone = false;
      }
    }

    this.setState(stateChange);

    if (!stateChange.validemail || !stateChange.validphone || !stateChange.validnames) return;

    return Api.createUser(data).then(
      answer => {
        if (!answer) {
          this.setState({ accountExists: true });
          return;
        }

        this.nextStep();
        return answer;
      },
      error => {
        this.setState({ error });
      }
    );
  }

  nextStep() {
    if (window.linkInstruments) {
      this.context.router.push('/checkout/payment')
    } else {
      this.context.router.push('/checkout/delivery');
    }
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    return (
      <div>
        <Steps current="1" />
        <div className="create-account page-flyout">
          <h2 className="flyout-header extra-space">Looks Like You're New!<br/>Let's Create An Account</h2>
          <div className="create-account-form">
            <div className={'row2' + (this.state.validnames ? '' : ' error')}>
              <div className="input col-50">
                <label htmlFor="first_name">First Name <span className="error-message">Invalid First Name</span></label>
                <input type="text" name="first_name" onChange={this.onChange} value={this.state.first_name} />
              </div>
              <div className="input col-50">
                <label htmlFor="last_name">Last Name <span className="error-message">Invalid Last Name</span></label>
                <input type="text" name="last_name" onChange={this.onChange} value={this.state.last_name} />
              </div>
            </div>
            <div className={'row2' + (this.state.validemail ? '' : ' error')}>
              <div className="input">
                <label htmlFor="email_address">Email <span className="error-message">Invalid Email</span></label>
                <input type="text" name="email_address" onChange={this.onChange} value={this.state.email_address} />
              </div>
            </div>
            <div className={'row2' + (this.state.validphone ? '' : ' error')}>
              <div className="input">
                <label htmlFor="phone_number">Phone Number <span className="error-message">Invalid Phone Number</span></label>
                <PhoneField name="phone_number" onChange={this.onChange} value={this.state.phone_number} />
              </div>
            </div>
            <div>
              <div className={'account-exists ' + (this.state.accountExists ? '' : 'hidden')}>
                An account with this email address or phone number already exists. Do you want to <Link to="/user">sign in</Link>?
              </div>
              <Button className="full-width" onClick={this.btnContinue}>Continue</Button>
              <p className="toc">By continuing, I agree to Indigo Fair’s <a href="/tos" target="_blank">Terms & Conditions</a></p>
              <Link className="already-have-account" to="/user">Already have an account? Sign In &gt;</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CreateAccount.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/checkout/CreateAccount.js
 **/